export default {
	tenantId: "tcb_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "tcb--uat-filesystem"
	}
}
